import OrderServeType from '@/constants/OrderServeType';
import { isEmpty } from 'lodash';
// enableInputName  一般外帶姓名必填
// showInputName  一般外帶姓名顯示
const showNameField = (webStoreVo, serveType, selectedTakeOutServeType) => {
  if (isEmpty(webStoreVo)) return false;
  const {
    webUiConfig: { showInputName, enableInputName },
  } = webStoreVo;

  // 一般外帶 姓名欄位 必填 就顯示  選填 看一般外帶 姓名欄位顯示設定
  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.TAKE_OUT &&
    (enableInputName || showInputName)
  ) {
    return true;
  }
  // 一般外帶 姓名欄位顯示設定
  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.TAKE_OUT &&
    showInputName
  ) {
    return true;
  }
  // 預約外帶&預約外送 姓名欄位一率顯示
  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT
  ) {
    return false;
  }
  if (serveType === OrderServeType.DELIVERY) {
    return true;
  }

  return false;
};

export default showNameField;
